import Service from '@/helpers/service'

export default {

    get(id) {
        return Service().get('sap-configuration/sap-sync-params/'+id);
    },
    show(id) {
        return Service().get('sap-configuration/sap-sync-params/show/'+id);
    },    
    create(params) {
        return Service().post('sap-configuration/sap-sync-params/create', params);
    },
    update(id, params) {
        return Service().post('sap-configuration/sap-sync-params/update/'+id, params);
    },
    delete(id) {
        return Service().post('sap-configuration/sap-sync-params/delete/'+id);
    }
}